import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";
import { SITE, SECTIONS } from "@/config/sections";
import { HOME } from "@/constants/testIds";
import { SectionLink } from "@/components/SectionLink";
import { MobileMenu } from "@/components/MobileMenu";
import { NavIcons } from "@/components/NavIcons";

export const Navbar = () => (
  <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#FDFBF7]/80 border-b border-[#F0EBE1]">
    <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
      <Link to="/" data-testid={HOME.brandLogo} className="flex items-center gap-2 group">
        <span className="w-9 h-9 rounded-full bg-[#E06D44] text-white grid place-items-center transition-transform duration-300 group-hover:rotate-12">
          <PawPrint size={18} />
        </span>
        <span className="font-heading font-bold text-lg tracking-tight">{SITE.name}</span>
      </Link>
      <div className="hidden md:flex items-center gap-1">
        {SECTIONS.map((s) => (
          <SectionLink
            key={s.id}
            url={s.url}
            nav
            data-testid={HOME.navLink(s.id)}
            className="px-4 py-2 rounded-full text-sm text-stone-600 hover:text-stone-900 hover:bg-[#F0EBE1] transition-colors"
          >
            {s.title}
          </SectionLink>
        ))}
      </div>
      <div className="flex items-center gap-1">
        <NavIcons />
        <MobileMenu />
      </div>
    </nav>
  </header>
);
